var _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfCarrot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.6326,
    cy: 19.7497,
    rx: 10.8274,
    ry: 4.33098,
    transform: "rotate(17.7668 11.6326 19.7497)",
    fill: "#8EC63F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.8274,
    ry: 4.33098,
    transform: "matrix(0.143827 -0.989603 -0.989603 -0.143827 26.0974 11.3378)",
    fill: "#8EC63F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.925,
    cy: 13.6111,
    rx: 10.8274,
    ry: 4.33098,
    transform: "rotate(-121.982 17.925 13.6111)",
    fill: "#8EC63F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3145 11.7848C32.075 7.96672 8.96955 21.7562 6.49692 34.1504C4.02429 46.5446 39.8565 74.2986 51.3365 67.1302C55.3399 64.6304 52.5131 61.7165 52.5131 58.4682C51.9186 55.8101 55.7613 48.9401 56.8441 47.6408C59.5509 44.3925 61.747 41.2007 60.6337 38.4746C55.3834 25.6188 46.4278 13.3186 42.3145 11.7848Z",
    fill: "#FC751B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0571 38.6967C38.0571 38.6967 41.9076 34.3776 45.0033 32.4445C48.099 30.5115 53.6699 28.9476 53.6699 28.9476",
    stroke: "#B05213"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1962 46.3932C47.1962 46.3932 49.8061 41.1442 56.844 38.4374",
    stroke: "#B05213"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCarrot);
export default __webpack_public_path__ + "static/media/half_carrot.e193286fb588c36810c2a7466594439c.svg";
export { ForwardRef as ReactComponent };